/**
 * Manage user email resets
 */
import Ajax from '@/lib/ajax_wrapper'

export function initUserEmailReset(id, user) {
  const url = `/users/${id}/reset_email`
  const method = 'POST'
  const data = {user}

  return Ajax.request({
    url,
    method,
    data
  })
}

export function completeUserEmailReset(id, token) {
  const url = `/admin/users/${id}/reset_email/${token}`
  const method = 'PATCH'

  return Ajax.request({
    url,
    method
  })
}
